import { handleAction, getTwilioInfoManagement } from '@/service/twilioService';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import Utils from '@/common/utils/utils';

export const initTwilioDevice = async (corpId, projectId, userId, chatThreadId) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        chatThreadId: chatThreadId,
        actionType: TelephoneConstant.ACTION.TWILIO_INIT_DEVICE,
        requestBody: JSON.stringify({
            test: 123
        })
    }

    const resultData = await handleAction(requestDto);
    return resultData;
};

export const handleDefineCallerInfoWhenIncomingCall = async (corporationDetail, projectInuseDetail, formParam, ticketId) => {
    const isPhoneNumber = Utils.isValidPhoneNumber(formParam);
    // CASE: Phone_call
    if (isPhoneNumber) {
        return await searchPhoneNumberInfo(corporationDetail.id, formParam);
    }

    // CASE: Voice_call
    const twilioInfo = Utils.parseTwilioAgentIdentity(formParam);
    if (!twilioInfo) return null;
    
    return await getIncomingVoiceCallerInfo(corporationDetail, projectInuseDetail, twilioInfo, ticketId);
};

const searchPhoneNumberInfo = async (corpId, phoneNumber) => {
    const requestDto = {
        corporationInuse: corpId,
        actionType: TelephoneConstant.ACTION.GET_INCOMING_INFO_BY_PHONE_NUMBER,
        requestBody: JSON.stringify({
            phoneNumber: phoneNumber
        })
    };

    const resultData = await getTwilioInfoManagement(requestDto);
    if (resultData && resultData.status && resultData.data) {
        try {
            const userInfo = resultData.data;
            return userInfo;
        } catch (err) {
            console.log('Error parsing user info:', err);
            return null;
        }
    }
    return null;
};

const getIncomingVoiceCallerInfo = async (corporationDetail, projectInuseDetail, twilioInfo, ticketId) => {
    const { projectId, userId } = twilioInfo;
    if (!corporationDetail || !projectInuseDetail || !projectId || !userId) return null;

    try {
        const requestDto = {
            corporationInuse: corporationDetail.id,
            projectInuse: projectInuseDetail.id,
            actionType: TelephoneConstant.ACTION.GET_INCOMING_INFO_VOICE_CALL,
            requestBody: JSON.stringify({
                callerProjectId: projectId,
                callerUserId: userId,
                ticketId,
            })
        };

        const resultData = await getTwilioInfoManagement(requestDto);

        if (!resultData?.data) return null;

        return resultData.data;

    } catch (error) {
        console.log('getIncomingVoiceCallerInfo error >>>', error);
        return null;
    }
}

export const getB2CUserList = async (corpId) => {
    const requestDto = {
        corporationInuse: corpId,
        actionType: TelephoneConstant.ACTION.GET_LIST_B2C_USER_INFO,
        requestBody: JSON.stringify({})
    };

    const resultData = await getTwilioInfoManagement(requestDto);
    if (resultData && resultData.status && resultData.data) {
        try {
            const userList = resultData.data;
            return userList;
        } catch (err) {
            console.log('Error parsing B2C user list:', err);
            return [];
        }
    }
    return [];
};

export const updatePhoneAvailability = async (corpId, projectId, userId, phoneAvailability) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.TWILIO_UPDATE_PHONE_AVAILABILITY,
        requestBody: JSON.stringify({
            phoneAvailability: phoneAvailability
        })
    }

    const resultData = await handleAction(requestDto);
    return resultData;
}

export const updateHeartbeatPhoneAvailability = async (corpId, projectId, userId) => {
    const requestDto = {
        corporationInuse: corpId,
        projectInuse: projectId,
        userId: userId,
        actionType: TelephoneConstant.ACTION.TWILIO_UPDATE_HEARTBEAT_PHONE_AVAILABILITY,
    }

    const resultData = await handleAction(requestDto);
    return resultData;
}

export const getB2CUserListInProject = async (corporationId, projectInuseId) => {
    const requestDto = {
        corporationInuse: corporationId,
        projectInuse: projectInuseId,
        actionType: TelephoneConstant.ACTION.GET_LIST_B2C_USER_INFO_IN_PROJECT,
        requestBody: JSON.stringify({})
    };

    const resultData = await getTwilioInfoManagement(requestDto);
    if (resultData && resultData.status && resultData.data) {
        try {
            const b2cList = resultData.data;
            return !Utils.isEmptyArray(b2cList) ? b2cList : [];
        } catch (err) {
            console.log('Error parsing B2C user list:', err);
            return [];
        }
    }
    return [];
};